export default __webpack_public_path__ + "static/media/3.0a1d8a53.webp";